export default function Privacy() {
  return (
    <section className="mt-6 sm:mt-10">
      <div className="card max-w-2xl mx-auto">
        <h1 className="text-3xl font-display font-bold text-navy mb-4">
          Your privacy &mdash; in plain English
        </h1>
        <p className="text-navy-700 mb-4">
          KindKudos is built to be radically anonymous. Here is exactly what we
          do and don&rsquo;t do.
        </p>
        <ul className="space-y-3 text-navy-700 list-disc pl-5">
          <li>
            <strong>The recipient never sees who sent the kudos.</strong> No
            name, no email, no hint. That&rsquo;s the whole point.
          </li>
          <li>
            We use <strong>Cloudflare Turnstile</strong> to block bots. It does
            not collect personal data.
          </li>
          <li>
            We <strong>temporarily rate-limit by IP</strong> (held in memory and
            a short-lived counter) so one person can&rsquo;t spam the world. We
            do not retain it.
          </li>
          <li>
            We ask for <strong>your email</strong> only to prevent abuse. We
            store a one-way <strong>SHA-256 hash</strong> of it &mdash; not the
            email itself. It is <strong>never shown to the recipient</strong>
            {' '}and <strong>never used for marketing</strong>.
          </li>
          <li>
            The <strong>recipient&rsquo;s email</strong> is used to deliver
            their one message and is stored only on that one kudos record.
          </li>
          <li>
            Every message is reviewed by AI (Google Gemini). If a message
            isn&rsquo;t kind, it&rsquo;s <strong>rejected and never stored</strong>.
          </li>
          <li>
            <strong>We can&rsquo;t tell the recipient who sent a kudos.</strong>
            {' '}We hold only a hash of your email; we can&rsquo;t reverse it,
            and we wouldn&rsquo;t.
          </li>
        </ul>
        <p className="text-navy-500 text-sm mt-6">
          Questions? <a href="mailto:hello@kindkudos.app">hello@kindkudos.app</a>
        </p>
      </div>
    </section>
  );
}
